export class TransitionSystem {
  constructor(layers, anim) {
    this.layers = layers;
    this.anim = anim;
  }

  async wipeLeftToRight(duration) {
    const inkCtx = this.layers.getInkCtx();
    const fxCtx = this.layers.getFxCtx();
    const canvasWidth = inkCtx.canvas.width;
    const canvasHeight = inkCtx.canvas.height;

    return new Promise((resolve) => {
      let t = 0;
      this.anim.add((dt) => {
        t += dt;
        const progress = Math.min(t / duration, 1);
        const x = canvasWidth * progress;

        // Clear ink progressively from left to right
        inkCtx.clearRect(0, 0, x, canvasHeight);

        // Draw dust particles
        fxCtx.clearRect(0, 0, canvasWidth, canvasHeight);
        for (let i = 0; i < 20; i++) {
          const px = x / window.devicePixelRatio + (Math.random() - 0.5) * 40;
          const py = (Math.random() * canvasHeight) / window.devicePixelRatio;
          fxCtx.fillStyle = `rgba(255, 255, 255, ${0.3 * (1 - progress)})`;
          fxCtx.fillRect(px, py, 2, 2);
        }

        if (progress >= 1) {
          // Fully clear ink and fx canvases
          this.layers.clearInk();
          this.layers.clearFx();
          resolve();
          return false;
        }
        return true;
      });
    });
  }

  async fade(duration) {
    const inkCtx = this.layers.getInkCtx();

    return new Promise((resolve) => {
      let t = 0;
      this.anim.add((dt) => {
        t += dt;
        const progress = Math.min(t / duration, 1);

        inkCtx.globalAlpha = 1 - progress;
        if (progress >= 1) {
          inkCtx.globalAlpha = 1;
          this.layers.clearInk();
          resolve();
          return false;
        }
        return true;
      });
    });
  }

  async none() {
    this.layers.clearInk();
    return Promise.resolve();
  }
}
